import styled from 'styled-components';
import { theme } from '../../../global';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${theme.spacings.s24};
`;

export const Description = styled.span`
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  color: ${theme.colors.secondaryText};
`;

export const Title = styled.span`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 32px;
  line-height: 136%;
  color: ${theme.colors.primaryText};

  @media (max-width: 500px) {
    font-size: 24px;
  }
`;

export const DateTitle = styled.span`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: 20px;
  line-height: 100%;
  color: ${theme.colors.primaryText};
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ArbitratorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacings.s8};
`;
